import React,{useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'


import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import {
    submitPayment
} from '../../actions'
import DragAndDrop from '../../components/dragAndDrop/file-upload.component'
import {MAKING_PAYMENT_LOADING_ID} from '../../store/loaders'
import { v4 as uuidv4 } from 'uuid'
import PopupModel from '../../components/models/popupModel'







const SuccessfulPayment = (props)=>{


    const dispatch = useDispatch()
    const history = useHistory()

    
    const apiResponse = useSelector(state=>{
        const {
            individualApplication,
            loader, 
            paymentStatus,
            generatedBillId,
            hasUpdatedIndividualApplication
        } = state
        const {application} = individualApplication
        const {status} = paymentStatus
        const {billId} = generatedBillId
        const payLoader = loader[MAKING_PAYMENT_LOADING_ID]

        return{
            application,
            status,
            billId,
            payLoader,
            hasUpdatedIndividualApplication
        }
    })

    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    var firm = props.location?.state?.firm
    var isMembership = props.location?.state?.isMembership
    var application = props.location?.state?.application



    const [requestId, setRequestId] = useState('')
    const [fileModel, showFileModel] = useState(false)
    const [paymentFile, setPaymentFile]  = useState('')


    const [newUserInfo, setNewUserInfo] = useState({
        profileImages: []
      });

    const updateUploadedFiles = (files) =>{
        setNewUserInfo(files);
    }
    
    useEffect(()=>{
        if(apiResponse.hasUpdatedIndividualApplication?.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.hasUpdatedIndividualApplication.message])

    var certifiedAwardUrl
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const handleSubmit = async ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)
        if(newUserInfo.length > 0){
            const fileUrl = await toBase64(newUserInfo[0]).then(value=>{
                certifiedAwardUrl = value.split(',')[1]
            })
        }
        setPaymentFile(certifiedAwardUrl)
        dispatch(submitPayment({
            data:{
                payer: currentUser.name,
                billId: apiResponse.billId?.id,
                userId: currentUser.sub,
                amount: apiResponse.billId?.amount,
                requestId:uuidv4(),
                paymentMethod:3,
                paymentProof: {
                    fileText: certifiedAwardUrl, 
                    type: newUserInfo[0]?.name?.split('.')?.pop(),
                    name: newUserInfo[0]?.name,
                    changed: true
                },
            },
            reqId:reqId
            
        }))
    }    
    const hanldePayLater = ()=>{
        history.push('/dashboard')
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/payment-details',
            state:{
                isFirm: firm,
                isMembership: isMembership,
                application
            }
        })
     }

     const handleRemoveItem = ()=>{
        setPaymentFile('')
    }

    return (
        <div>
            <DashboardHeader 
                activeStep={8}
                application={props.location?.state?.application}
                />
            <DashBoardContainer 
                title="Submit"
                middleTitle="Pay later"
                handleCancel={handleCancel}
                handleSaveForLater={hanldePayLater}
                handleSubmit={handleSubmit}
                isFetching={apiResponse.payLoader?.isLoading}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <span className="general-span-text-none-auto" style={{textAlign: 'center'}}>Thank You,<br/>
                        You can pay your application fee within 30 days.</span> 
                    <div className="d-flex" style={{
                            alignItems: 'center', 
                            justifyContent: 'center',
                            flexDirection: 'column'
                            }}>
                        <span className="general-span-text-none-auto" >Your generated application bill ID is:<br/></span>
                        <span className="dashboard-green-text-header"> {apiResponse.billId?.id}</span>
                    </div>

                </div>

                    <div className="mt-4" style={{
                        padding: 20
                    }}>
                        <span className="general-span-text-none-auto">If you may need to pay or transfer via the bank here are bank details:</span> <br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Bank: <span style={{color: '#0f3589'}}> GT Bank</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Account Number: <span style={{color: '#0f3589'}}> 211131222151180/RWF</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Amount: <span style={{color: '#0f3589'}}> {apiResponse.billId?.amount}</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Account name:<span style={{color: '#0f3589'}}> Institute of Engineers Rwanda</span></span><br/>
                        <span className="general-span-text-none-auto" style={{fontSize: '18px'}}>Transaction description:<span style={{color: '#0f3589'}}> Paying application fee for Bill ID: {apiResponse.billId?.id} </span></span>
                    </div>
                <div style={{width: '50%', marginLeft: '25%'}} className="mt-4">
                    <DragAndDrop
                        accept=".jpg,.png,.jpeg"
                        label={`Upload proof of payment,
                        paid for Bill ID: ${apiResponse.billId?.id}`}
                        multiple
                        updateFilesCb={updateUploadedFiles}
                        handleRemoveItem= {handleRemoveItem}
                        dragText={true}
                        hide={true}
                        showFileModel={showFileModel}
                        savedFile={paymentFile}
                        fileName={paymentFile?.name}
                    />
                </div>
                <PopupModel
                    show={fileModel}
                    hide={()=>showFileModel(false)}
                    content="File uploaded is too big"
                    btnText="OK"
                    handleConfirm={()=>showFileModel(false)}
                    />
            </DashBoardContainer>
        </div>
    )
}

export default SuccessfulPayment